import { render, staticRenderFns } from "./NotificationModal.vue?vue&type=template&id=ae310b42&scoped=true"
import script from "./NotificationModal.vue?vue&type=script&lang=js"
export * from "./NotificationModal.vue?vue&type=script&lang=js"
import style0 from "./NotificationModal.vue?vue&type=style&index=0&id=ae310b42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae310b42",
  null
  
)

export default component.exports